import React, {useEffect} from 'react';
import {logPageLoadEvents} from '@ibibo/analytics';
import {useSelector, useDispatch} from 'react-redux';
import {userDataSelector, prevPageNameSelector} from '../../store/selectors';
import {updatePreviousPageName} from '../../store/actions'

import VerificationRequired from '../../stories/components/Onboarding/VerficationRequired/VerificationRequired';
import Onboarding from '../../stories/components/Onboarding/onboarding';

const VerificationPage = () => {

  const userInfo = useSelector(userDataSelector);
  const { email, mobile, requestIp, accountId } = userInfo;
  const data = useSelector(prevPageNameSelector);
  const {prevPageName} = data;
  const dispatch = useDispatch();

  useEffect(() => {
    const events = {
      eVar34: email,
      eVar35: mobile,
      eVar23: prevPageName,
      eVar28: requestIp,
      eVar67: accountId,
      eVar24: "onboarding|mypartner",
      eVar37: "domain_sbu:india|domain_country:in|domain_currency:inr|domain_language:eng",
    }

    logPageLoadEvents('onboarding:verificationpending', events);
    dispatch(updatePreviousPageName("onboarding:verificationpending"));
  }, [dispatch]);

  return (
    <Onboarding step={5}>
      <VerificationRequired />
    </Onboarding>
  );
};

export default VerificationPage;
